import StopIcon from "@material-ui/icons/Stop";
import React from "react";

interface PropsFromParent {
  text: string;
  color: string;
}

export class GraphLegend extends React.PureComponent<PropsFromParent> {
  private stopIconStyle = { color: this.props.color };

  public render() {
    return (
      <div className={"flexDirectionRow"}>
        <StopIcon style={this.stopIconStyle} />
        <div className="alignSelfCenter">{this.props.text}</div>
      </div>
    );
  }
}
